module.exports = __webpack_public_path__ + "static/media/fly0107.5007308b.webp";